// src/Pages/Landing/JoyrideTampereLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideTampereLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Tampere"
      maakunta="Pirkanmaa"
      nearbyAreas={[
        "Nokia",
        "Ylöjärvi",
        "Pirkkala",
        "Lempäälä",
        "Kangasala",
        "Valkeakoski"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Tampereella ja Pirkanmaan alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Tampere sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Tampereen keikoissa kokonaisuus sovitaan aina tapahtuman aikataulun ja paikan mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}